import { of } from 'rxjs';
var HomeUrlHelperStub = /** @class */ (function () {
    function HomeUrlHelperStub() {
    }
    HomeUrlHelperStub.prototype.generateLegacyToken = function (token) {
        return of('testToken');
    };
    HomeUrlHelperStub.prototype.addUrlParam = function (baseUrl, params) {
        return baseUrl + '?' + params[0];
    };
    HomeUrlHelperStub.prototype.urlByOrigin = function (url, origin) {
        return url;
    };
    HomeUrlHelperStub.prototype.generateDynamoPortalToken = function () {
    };
    HomeUrlHelperStub.prototype.generateClimaVistaUrl = function () {
    };
    HomeUrlHelperStub.prototype.urlByIndexJSON = function () {
    };
    HomeUrlHelperStub.prototype.addTokenUrlItem = function () {
    };
    HomeUrlHelperStub.prototype.shouldBeRouted = function () {
    };
    HomeUrlHelperStub.prototype.setJSONIndex = function () {
    };
    HomeUrlHelperStub.prototype.getFromJSON = function () {
    };
    HomeUrlHelperStub.prototype.urlItemMode = function () {
    };
    return HomeUrlHelperStub;
}());
export { HomeUrlHelperStub };
